import { MoniebookLoader } from '@moniebook-web/components/molecules/moniebook-loader';
import { NotFound } from '@moniebook-web/components/widgets/not-found';
import { Unauthorized } from '@moniebook-web/components/widgets/unauthorized';
import { PAGES } from '@moniebook-web/types';
import { Navigate, type RouteObject } from 'react-router';

import { GHOST_SESSION_PAGES } from '@/features/ghost-session/constants';
import { GhostSessionEnded } from '@/features/ghost-session/ended/ghost-session-ended';
import { GhostSessionExpired } from '@/features/ghost-session/expired/ghost-session-expired';
import { GhostSessionInit } from '@/features/ghost-session/init/ghost-session-init';
import { Dashboard } from '@/features/shared/layout/dashboard/dashboard';

import { accountingRoutes } from './accounting-ui';
import { authRoutes } from './auth-ui';
import { businessMgtRoutes } from './business-mgt-ui';
import { customerRoutes } from './customers-ui';
import { dashboardRoutes } from './dashboard-ui';
import { inventoryOnboardingRoutes } from './inventory-onboarding-ui';
import { onboardingRoutes } from './onboarding-ui';
import { ordersRoutes } from './orders-ui';
import { productsRoutes } from './products-ui';
import { registersRoutes } from './registers-ui';
import { reportsRoutes } from './reports-ui';
import { RouteWrapper } from './route-wrapper';
import { saleSettingsRoutes } from './sale-settings-ui';
import { settingsRoutes } from './settings-ui';

const notFoundRoute = { path: 'not-found', element: <NotFound /> };

const unauthorized = { path: 'unauthorized', element: <Unauthorized /> };

const ghostSessionInit = {
    path: GHOST_SESSION_PAGES.INIT,
    element: <GhostSessionInit />,
};

const ghostSessionExpired = {
    path: GHOST_SESSION_PAGES.EXPIRED,
    element: <GhostSessionExpired />,
};

const ghostSessionEnded = {
    path: GHOST_SESSION_PAGES.ENDED,
    element: <GhostSessionEnded />,
};

export const dashboardAppRoutes: RouteObject = {
    path: 'dashboard',
    element: <Dashboard />,
    children: [
        { path: '', element: <Navigate to={PAGES.HOME} replace /> },
        unauthorized,
        notFoundRoute,
        ...dashboardRoutes,
        ...businessMgtRoutes,
        ...settingsRoutes,
        ...accountingRoutes,
        ...customerRoutes,
        ...inventoryOnboardingRoutes,
        ...onboardingRoutes,
        ...ordersRoutes,
        ...registersRoutes,
        ...reportsRoutes,
        ...saleSettingsRoutes,
        ...productsRoutes,
    ],
};

export const appRoutes: RouteObject[] = [
    {
        path: '/',
        hydrateFallbackElement: <MoniebookLoader fullHeight />,
        element: <RouteWrapper />,
        children: [
            ...authRoutes,
            dashboardAppRoutes,
            ghostSessionInit,
            ghostSessionExpired,
            ghostSessionEnded,
            {
                path: '',
                element: <Navigate to={PAGES.HOME} replace />,
            },
            unauthorized,
            notFoundRoute,
        ],
    },
];
